import { useMemo } from "react";

export function usePayeeEngagementHistoryResources(
  payerPayeeEngagementId: string
) {
  return useMemo(
    () => [
      {
        resourceType: "PayerPayeeEngagement",
        resourceId: payerPayeeEngagementId
      }
    ],
    [payerPayeeEngagementId]
  );
}
